/**
 * Whether an admin has the Sales Tax switch on (Platform Fees; Tyler,
 * 2026-10-21: "when it is off we don't charge sales tax"), for the pieces
 * web shows only while it is: the store menu's Tax Compliance entry, the
 * receipts banner on Listings and Inventory, the Inventory page's sales-tax
 * filter, the item editor's Sales tax row, Account Standing's Tax records
 * row, and the Guides page's Sales Tax on Rentals card. The pages
 * themselves answer not found while it is off (salesTaxLoaders).
 *
 * False until the server answers, so no piece shows and then vanishes. A
 * read that fails leaves them hidden too; the backend logs that failure,
 * and a missing switch row fails checkout as loudly.
 */
import { useGetSalesTaxSwitchQuery } from '@/redux/api/salesTaxApi'

export const useSalesTaxEnabled = (): boolean => {
  const { data } = useGetSalesTaxSwitchQuery()
  return data?.enabled === true
}
